import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name: "loader",
    initialState: {
        message: "Loading...",
        open: false,
    },
    reducers: {
        showLoader: (state, action) => {
            state.open = true;
            state.message = action.payload
                ? action.payload.message
                : "Loading...";
        },
        hideLoader: (state) => {
            state.open = false;
            state.message = "Loading...";
        },
    },
});

export const { showLoader, hideLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
